import React, {useContext, useEffect, useRef, useState} from 'react';
import {Video} from "../UIComponents/Video/Video";
import Modal from "../UIComponents/Modal/Modal";
import styles from "./MapIntroVideo.module.css";
import {FaWindowClose} from "react-icons/fa";
import {basicSessionInfoContext, BasicSessionInfoContextType} from "../../utils/BasicSessionContext";
import {categoryTreeContext, CategoryTreeContextType} from "../../utils/CategoryTreeContext";
//@ts-ignore
import captions from "../../assets/vtt/onboarding_subtitles.vtt";
import {useTranslateGlobal, useTranslatePage} from "../../utils/TranslationHooks";

//Use this to test the modal locally
const testIntroVideo = false; //Should be false on commit

if (testIntroVideo) {
    localStorage.removeItem("abp_dontShowIntro");
}

interface Props{
    openedManually?: boolean;
    onClose: () => void;
}

export const MapIntroVideo = ({openedManually, onClose}: Props) => {
    const {cmsLangId} = useContext(basicSessionInfoContext) as BasicSessionInfoContextType;
    const [show, setShow] = useState(!localStorage.abp_dontShowIntro || openedManually);

    const translateGlobal = useTranslateGlobal();
    const translatePage = useTranslatePage("LetterPage");

    let captions = "";
    let videoUrl = "";

    switch(cmsLangId){
        case "<1>": //Bokmål
            captions = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/video-info/onboarding_no_nb.vtt";
            videoUrl = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/video-info/onboarding_versjon_05.mp4";
            break;
        case "<3>": //Nynorsk
            captions = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/video-info/onboarding_no_nn.vtt";
            videoUrl = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/video-info/onboarding_versjon_05.mp4";
            break;
        case "<8>": //Swedish
            captions = "";
            videoUrl = "https://alphabet-planet-ui.s3.eu-west-1.amazonaws.com/video-info/onboarding_sve.mp4";
            break;
        default:
    }

    useEffect(() => {
        //Only show the video once
        localStorage.abp_dontShowIntro = true;
    }, []);

    useEffect(() => {
        if(openedManually) {
            setShow(true)
        }
    }, [openedManually]);

    if (!show) { 
        return null;
    }

    return (
        <Modal
            heading={translatePage("Onboarding-heading")}
            backdropClicked={() => {
                setShow(false);
                onClose();
        }} show={show}>
            <div className={styles.container}>
                <div className={styles.mainContent}>
                    <Video
                        src={videoUrl}>
                        <track
                            src={captions}
                            kind="captions"
                            srcLang="no"
                        />
                    </Video>
                </div>
                <button 
                    className={styles.closeButton}
                    onClick={() => {
                        setShow(false); 
                        onClose();
                    }}>
                    <FaWindowClose aria-label={translateGlobal("CloseWindow")}/>
                </button>
            </div>
        </Modal>
    )
}